import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {BidService} from '../../services/bid.service';
import {AlertService} from '../../services/alert.service';
import {StorageService} from '../../services/storage.service';
import {LoadingController} from '@ionic/angular';
import {IFingerEnroll} from '../../interfaces/finger.enroll';

@Component({
  selector: 'app-correo-electronico-contrato',
  templateUrl: './correo-electronico-contrato.page.html',
  styleUrls: ['./correo-electronico-contrato.page.scss'],
})
export class CorreoElectronicoContratoPage implements OnInit {

  credentials: FormGroup;
  operationId: string;
  speaker: string;
  type: string;
  personIdRegister: string;
  userId: string;
  fingerLst;
  user;
  userType: number;
  typeClient: string;
  facialProvider = 'IDENTY';

  constructor(private fb: FormBuilder,
              private router: Router,
              private bidService: BidService,
              private alertService: AlertService, private storageService: StorageService,
              private loadingController: LoadingController) {
  }

  get email() {

    return this.credentials.get('email');
  }

  ngOnInit() {

    this.bidService.config().subscribe((con: any []) => {

      let dat = [
        {
          'id': '1130',
          'type': 'DW',
          'cfgGroup': 'FACIAL',
          'parameter': 'FACIAL_PROVIDER',
          'value': 'IDENTY',
          'description': 'Identy',
          'active': false,
          'registerDate': '2021-07-06T03:38:21.198Z',
          'lastUpdateDate': null,
          'version': 1
        },
        {
          'id': '1121',
          'type': 'DW',
          'cfgGroup': 'BYPASS',
          'parameter': 'VENTA-A-SI-MISMO',
          'value': 'false',
          'description': 'ByPass agente se venda a si mismo',
          'active': true,
          'registerDate': '2021-04-27T03:11:22.293Z',
          'lastUpdateDate': null,
          'version': 1
        },
        {
          'id': '1122',
          'type': 'DW',
          'cfgGroup': 'FACIAL',
          'parameter': 'FACE-RATIO',
          'value': '.40',
          'description': 'RATIO EVALUACION DE COMPARACION FACIAL',
          'active': true,
          'registerDate': '2021-04-27T03:11:22.293Z',
          'lastUpdateDate': null,
          'version': 1
        }
      ];
      const lstfacialProvider = dat.filter(config => config.parameter === 'FACIAL_PROVIDER');
      if (lstfacialProvider.length > 0) {
        console.log(lstfacialProvider[0].value);
        this.facialProvider = lstfacialProvider[0].value;
        console.log(this.facialProvider);
      }
    });
    this.credentials = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.credentials.get('email').valueChanges.subscribe((event) => {
      this.credentials.get('email').setValue(event.toLowerCase(), {emitEvent: false});
    });

    this.storageService.getStorage('type').then(data => {
      this.type = data.value;
      if (this.type === 'register') {
        this.userType = 1;
        this.typeClient = 'Agente';
        this.user = 'Ingresa el correo electrónico en donde recibirás notificaciones del proceso';
      } else {
        this.userType = 2;
        this.typeClient = 'Cliente';
        this.user = 'Ingresa  el correo electrónico en donde le llegará  el contrato al cliente';
      }
    });

    this.storageService.getStorage('personIdRegister').then((op: any) => {

      this.personIdRegister = op.value;
    });

    this.storageService.getStorage('userId').then((op: any) => {

      this.userId = op.value;
    });

    this.storageService.getStorage('operationID').then((op: any) => {

      this.operationId = op.value;
    });

    this.storageService.getStorage('speaker').then((sp: any) => {

      this.speaker = sp.value;
    });

    this.storageService.getStorage('ENROLLFINGER').then(dataFinger => {
      this.fingerLst = JSON.parse(dataFinger.value);

      this.verifyAgentFinger();
    });
  }

  verifyAgentFinger() {
    const reqFinger = {
      operationId: this.operationId,
      data: {
        userType: this.userType,
        speaker: this.speaker,
        rightindex: this.fingerLst[4].base64,
        rightmiddle: this.fingerLst[5].base64,
        rightring: this.fingerLst[6].base64,
        rightlittle: this.fingerLst[7].base64,
        leftindex: this.fingerLst[0].base64,
        leftmiddle: this.fingerLst[1].base64,
        leftring: this.fingerLst[2].base64,
        leftlittle: this.fingerLst[3].base64,
      }
    };

    console.log(reqFinger);
    this.bidService.fingerVerify(reqFinger).subscribe(data => {

    });
  }

  faceCapture() {

    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });

    this.storageService.getStorage('operationID').then((op: any) => {
      this.operationId = op.value;
      console.log("GetIdOpEmail", this.operationId);
      const req = {
        operationId: this.operationId,
        data: {
          email: this.credentials.value.email.toLowerCase()
        }
      };
      this.bidService.validateEmail(req).subscribe(async (data: any) => {
  
        if (data.Result === 'NOK') {
          this.loadingController.dismiss();
          const responseAlert = await this.alertService.presentAlert('Cuidado', 'Correo electronico no valido');
        } else {
          this.loadingController.dismiss();
          this.validateEmailExist();
        }
      });
    });


    
  }

  validateEmailExist() {

    this.bidService.validateEmailExist(this.credentials.value.email.toLowerCase()).subscribe(async (data: any) => {

      if (data.length > 0) {
        // ya existe registro
        const responseAlert = await this.alertService.presentAlert('Error', 'Correo electrónico  existe en un enrolamiento previo');
        console.log(responseAlert);
      } else {
        this.loadingController.dismiss();

        if (this.type === 'register') {

          const req = {
            code: this.speaker,
            email: this.credentials.value.email.toLowerCase()
          };

          this.storageService.saveToStorage('emailPerson', this.credentials.value.email.toLowerCase());
          let sto = this.storageService.getStorage('emailPerson');
          console.log("emailPerson", sto);

          this.bidService.updatePerson(this.personIdRegister, req).subscribe();

          this.enroll();
        } else {

          const req = {
            currentSecuenceId: '12',
            activityValue: 'CUSTOMER_VERIFICATION_NOT_FOUND_BY_EMAIL'
          };
          this.bidService.updateOperation(this.operationId, req).subscribe();

          this.enroll();

        }

      }
    });
  }


  createPerson() {

    const reqBiometric = {
      personId: this.personIdRegister,
      boimetricId: 1,
      fingers: true,
      biometricFingersCode: 'CONFIG_FINGER_1'
    };
    this.bidService.personBiometricData(reqBiometric).subscribe();

    if (this.type !== 'register') {
      const reqPerson =
        {
          personTypeId: 1,
          email: this.credentials.value.email.toLowerCase(),
          code: this.speaker
        };
      this.bidService.createPerson(reqPerson).subscribe((resp: any) => {
        this.storageService.saveToStorage('personID', String(resp.id)).then();
        const reqOp = {
          personId: String(resp.id),
          currentSecuenceId: '12',
          activityValue: 'EMAIL_OK',
        };
        this.bidService.updateOperation(this.operationId, reqOp).subscribe(respOp => {
          this.loadingController.dismiss();
          if (this.facialProvider === 'IDENTY') {
            this.router.navigateByUrl('/dashboard/face').then();
          } else {
            this.router.navigateByUrl('/dashboard/face2').then();

          }
        });
      });
    } else {
      const reqOp = {
        personId: this.personIdRegister,
        currentSecuenceId: '12',
        activityValue: 'EMAIL_OK',
      };
      this.bidService.updateOperation(this.operationId, reqOp).subscribe(respOp => {
        this.loadingController.dismiss();
        if (this.facialProvider === 'IDENTY') {
          this.router.navigateByUrl('/dashboard/face').then();
        } else {
          this.router.navigateByUrl('/dashboard/face2').then();

        }
      });
    }

  }

  enroll() {
    try {
      const reqFinger: IFingerEnroll = {
        operationId: Number(this.operationId),
        data: {
          speaker: this.speaker,
          personID: Number(this.personIdRegister),
          userId: Number(this.userId),
          userType: this.userType,
          numOfFingers: 8,
          rightindex: this.fingerLst[4].base64,
          rightmiddle: this.fingerLst[5].base64,
          rightring: this.fingerLst[6].base64,
          rightlittle: this.fingerLst[7].base64,
          leftindex: this.fingerLst[0].base64,
          leftmiddle: this.fingerLst[1].base64,
          leftring: this.fingerLst[2].base64,
          leftlittle: this.fingerLst[3].base64,
        }
      };

      this.bidService.enrollFinger(reqFinger).subscribe((data: any) => {
        console.log(data);
        if (data.error === undefined) {
          this.createPerson();
        } else {
          this.alertService.presentAlert('Error', 'No se pudo enrolar ' + this.typeClient);
        }
      }, error => {
        console.log(error);
        this.alertService.presentAlert('Error', 'No se pudo enrolar el' + this.typeClient);

      });
    } catch (err) {
      console.log(err);
      this.alertService.presentAlert('Error', 'No se pudo enrolar el agente' + this.typeClient);

    }


  }

  lowerCaseEmail() {
    console.log('asdad');
    this.credentials.value.email.toLowerCase();
  }

}
